import { ArrowLeftOutlined } from '@ant-design/icons'
import { Button, PageHeader, Space } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

const MachinePartsPageHeader = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <div style={{ justifyContent: 'space-between', width: '100%' }}>
      <Space>
        <Button onClick={() => navigate('/machines')} icon={<ArrowLeftOutlined />}></Button>
        <PageHeader ghost={false} title={t('components.pages.machineParts.list.pageHeader.title')} />
      </Space>
    </div>
  )
}

MachinePartsPageHeader.displayName = 'MachinePartsPageHeader'
export default MachinePartsPageHeader
